/* global axios */
import ApiClient from './ApiClient';

class PosOrdersApi extends ApiClient {
  constructor() {
    super('pos_orders', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(posOrder) {
    return axios.post(this.url, { pos_order: posOrder });
  }

  update(id, posOrder) {
    return axios.put(`${this.url}/${id}`, { pos_order: posOrder });
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new PosOrdersApi();
